import type { Fetcher } from 'swr';

import axiosWithAuth from '@/lib/axios';

import type { PostalItemDetail } from './types';
import { postalItemDetailSchema } from './types';

export const detailFetcher: Fetcher<PostalItemDetail> = async (url: string) => {
  const { data } = await axiosWithAuth.get(url);
  const detail = postalItemDetailSchema.parse(data);
  return detail;
};
